export const loginRequest = {
  scopes: ["User.Read", "https://vault.azure.net/user_impersonation"],
};
